<template>
    <div>
      <NoticeBar />
      <div v-if="show">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="ad in ads" :key="ad.id"><a :href="ad.url"><img :src="ad.thumbnail" width="100%" /></a></van-swipe-item>
        </van-swipe>
        <div class="nav-tab" :style="`height: `+vHeight+`px`">
          <ul>
            <li>
              <a @click="goodsDetails(3)">
                <span>
                  <img src="../../assets/images/in-vip.png" height="220" />
                </span>
              </a>
            </li>
            <li>
              <a @click="goodsDetails(2)">
                <span>
                  <img src="../../assets/images/in-dl.png" height="220" />
                </span>
              </a>
            </li>
          </ul>
        </div>
        <!--
        <div class="nav-tab">
          <ul>
            <li>
              <router-link to="/index/details?id=1">
                <span>
                  <img src="../../assets/images/ico_05.png" height="40" />
                </span>
                <p>企业简介</p>
              </router-link>
            </li>
            <li>
              <router-link to="/index/details?id=2">
                <span>
                  <img src="../../assets/images/ico_06.png" height="40" />
                </span>
                <p>品牌介绍</p>
              </router-link>
            </li>
            <li>
              <router-link to="/index/details?id=3">
                <span>
                  <img src="../../assets/images/ico_07.png" height="40" />
                </span>
                <p>沃隆商学院</p>
              </router-link>
            </li>
            <li>
              <router-link to="/index/details?id=4">
                <span>
                  <img src="../../assets/images/ico_08.png" height="40" />
                </span>
                <p>代理权益</p>
              </router-link>
            </li>
          </ul>
        </div>
      -->
        <!--
        <div class="index-a">
          <router-link :to="{ path: '/goods/details', query: {id: 2}}">
            <div class="i-a-li">
              <h3><img src="../../assets/images/i_hd.png" height="25" />沃隆植萃精华液</h3>
              <img src="https://img.guangdongganfa.com/images/in_01.jpg" width="100%" />
            </div>
          </router-link>
          <router-link :to="{ path: '/goods/details', query: {id: 3}}">
            <div class="i-a-li">
              <h3><img src="../../assets/images/i_hd.png" height="25" />沃隆植萃洗发水</h3>
              <img src="https://img.guangdongganfa.com/images/in_02.jpg" width="100%" />
            </div>
          </router-link>
        </div>
      -->
      <!--
        <div class="van-hairline--top"></div>
        <div class="index-a">
          <router-link to="/goods/details">
            <div class="i-a-li">
              <h3><img src="../../assets/images/i_md.png" height="25" />VIP</h3>
              <img src="../../assets/images/i_vip.png" width="100%" />
            </div>
          </router-link>
        </div>
        <div class="van-hairline--top"></div>
        <div class="index-a">
          <a @click="upgrade">
            <div class="i-a-li">
              <h3><img src="../../assets/images/i_qy.png" height="25" />代理区</h3>
              <img src="../../assets/images/i_dl.png" width="100%" />
            </div>
          </a>
        </div>
      -->
      </div>
      <Laod ref="laoding" />
      <Footer />
    </div>
</template>

<script>
  import { Swipe, SwipeItem,Dialog } from 'vant';
  import wx from 'weixin-js-sdk'

  export default {
    components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Dialog.Component.name]: Dialog.Component,
    },
    name: 'index',
    data() {
      return {
        show: false,
        ads: [],
        user: [],
        isActivity: 0,
        vHeight: 400,
        link: '',
      };
    },
    created() {
      // 判断如果是普通用户并且有升级订单
      if(localStorage.getItem('grade_id') == 4 && localStorage.getItem('upgrade_members_grade_id') != 0){
        Dialog.alert({
          message: '您有未支付的注册、升级订单，请尽快付款！',
        }).then(() => {
          this.$router.push({name: 'orders'})
        })
      }else{
        this.getData()
        this.getNotice()
      }
      this.vHeight = window.innerHeight - 250;
      //console.log(this.vHeight);
      this.link = process.env.DOMAIN_NAME;
    },
    methods: {
      getJssdkConfig(apis, debug, json, link){
        let self = this
        this.$api.get('jssdkConfig', {apis:apis, debug:debug, json:json, url: link}, r=>{
          let config = JSON.parse(r.data)
          wx.config(config);
          wx.ready(function() {
            let shareData = {
              title: '沃隆多肽倍护精华液套盒',
              desc: '沃隆多肽倍护精华液套盒',
              link: self.link,
              imgUrl: self.ads[0].thumbnail,
              success: function () {}
            }
            wx.showOptionMenu()
            wx.updateAppMessageShareData(shareData)
            wx.updateTimelineShareData(shareData)
          })
          wx.error(function(error){
            //console.log(error)
          })
        })
      },
      getData() {
        this.$api.get('users/index', null, r=>{
          this.ads = r.data.ads
          this.user = r.data.user
          this.isActivity = this.user.is_activity
          this.show = true
          this.$refs.laoding.loadClose()
          this.getJssdkConfig("checkJsApi,updateAppMessageShareData,updateTimelineShareData", false, false, window.location.href.split('#')[0]);
        })
      },
      getNotice() {
        this.$api.get('informations/show', null, r=>{
          if(Object.keys(r.data).length > 0){
            localStorage.setItem('commonInformation', r.data.content);
          }else{
            localStorage.removeItem('commonInformation')
          }
        })
      },
      goodsDetails(type) {
        if(this.user.phone != '' && this.user.phone != null){
          let members_grade_id = this.user.members_grade_id
          if(members_grade_id == 4){
            this.$toast('您不是VIP会员无法购买，请联系客服')
            return;
          }
          if(type == 2){
            if(members_grade_id == 3){
              this.$toast('您不是代理商，请进入VIP界面购买')
            }else if(members_grade_id == type){
              this.$router.push({name: 'GoodsDetails'})
            }
          }else if(type == 3){
            if(members_grade_id == type){
              this.$router.push({name: 'GoodsDetails'})
            }else{
              this.$toast('您不是VIP会员，请进入代理商界面购买')
            }
          }
        }else{
          Dialog.alert({
            message: '您还未绑定手机号，请绑定后再购买！',
          }).then(() => {
            this.$router.push({name: 'binding'})
          })
        }
      },
      upgrade() {
        // console.log(this.user)
        if(this.user.phone != '' && this.user.phone != null){
          let members_grade_id = this.user.members_grade_id
          if(members_grade_id == 1) {
            this.$toast('您已经是最高等级啦')
          }else if(localStorage.getItem('upgrade_members_grade_id') == 2){
            this.$toast('您的升级订单还未支付')
          }else if(localStorage.getItem('upgrade_members_grade_id') == 1){
            this.$toast('您的升级订单已经在审核中啦')
          }else{
            this.$router.push({name: 'upgrade'})
          }
        }else{
          Dialog.alert({
            message: '您还未绑定手机号，请绑定后再购买！',
          }).then(() => {
            this.$router.push({name: 'binding'})
          })
        }
      }
    },
  }
</script>

<style scoped>
  .my-swipe .van-swipe-item {
    text-align: center;
  }
  .nav-tab{
    overflow: hidden;
    padding: 3% 0;
    background: url('https://img.guangdongganfa.com/images/bg_01.png') repeat-y;
    background-size: 100%;
  }
  .nav-tab ul li{
    padding: 1% 0;
    width: 50%;
    float: left;
    text-align: center;
  }
  .nav-tab ul li a{
    display: block;
  }
  .nav-tab ul li span{
    display: block;
  }
  .nav-tab ul li p{
    margin: 0;
    font-size: 14px;
  }
  .index-a{
    overflow: hidden;
    background: #ffffff;
    padding:3%;
  }
  .index-a .i-a-li{

  }
  .index-a .i-a-li h3{
    margin: 0;
    line-height: 30px;
    padding-bottom: 5px;
    font-weight: normal;
    font-size: 16px;
  }
  .index-a .i-a-li h3 img{
    float: left;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue